import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "card reports-holds"
}
const _hoisted_3 = {
  key: 0,
  class: "report-container"
}
const _hoisted_4 = { class: "table-total" }
const _hoisted_5 = { class: "label-text-total" }
const _hoisted_6 = { class: "reports-container-table" }
const _hoisted_7 = { class: "report-table" }
const _hoisted_8 = {
  key: 1,
  class: "report-no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "table-title" }, [
          _createElementVNode("h2", { class: "title-main" }, "Holds Report")
        ], -1)),
        ($setup.holdsByReport.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label-text-total" }, "Total holds:", -1)),
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.holdsByReport.length), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", null, [
                    _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Project"),
                        _createElementVNode("th", null, "Lot Number"),
                        _createElementVNode("th", null, "Assigned to"),
                        _createElementVNode("th", null, "Price"),
                        _createElementVNode("th", null, "Hold Granted"),
                        _createElementVNode("th", null, "Hold Expires")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.holdsByReport, (hold, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(hold.estateTitle), 1),
                          _createElementVNode("td", null, "lot " + _toDisplayString(hold.lotTitle), 1),
                          _createElementVNode("td", null, _toDisplayString(hold.fullName), 1),
                          _createElementVNode("td", null, _toDisplayString($setup.formatPrice(hold.price)), 1),
                          _createElementVNode("td", null, _toDisplayString($setup.formatDate(hold.createdAt)), 1),
                          _createElementVNode("td", null, _toDisplayString($setup.formatDate(hold.expirationDate)), 1)
                        ]))
                      }), 128)),
                      _cache[1] || (_cache[1] = _createElementVNode("tr", { "empty-row": "" }, [
                        _createElementVNode("td", {
                          class: "td-spacing",
                          colspan: "6"
                        })
                      ], -1))
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
            ]))]))
      ]))
}